<template>
  <div class="commonWorkorderTable">
    <b-table
      :items="workorderItem"
      :fields="workorderFields"
      sticky-header="447px"
      :no-border-collapse="true"
      class="text-center orderManagement-common-workorder-table-detail"
    >
      <template #cell(work_qty)="data" style="">
        {{ data.value.toLocaleString("en-US") }}
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "commonWorkorderTable",
  props: {
    workorderItem: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      workorderFields: [
        {
          key: "work_code",
          label: "工單編號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "comm_code",
          label: "料號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "control_card",
          label: "管制卡號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "comm_name",
          label: "料名",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "work_qty",
          label: "派工支數",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        }
      ]
    };
  },
  created: function() {},
  mounted: function() {},
  components: {},
  watch: {},
  computed: {},
  methods: {
    onClick() {}
  },
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss">
.orderManagement-common-workorder-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.orderManagement-common-workorder-table-detail th,
.orderManagement-common-workorder-table-detail td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-right: 1px solid;
  border-bottom: 1px solid #999999 !important;
  font-size: 1.125rem;
  font-weight: normal;
  vertical-align: middle !important;
}
.orderManagement-common-workorder-table-detail td {
  font-size: 1rem;
}
.orderManagement-common-workorder-table-detail th:first-child,
.orderManagement-common-workorder-table-detail td:first-child {
  border-left: 1px solid;
}
.orderManagement-common-workorder-table-detail thead th {
  color: #ffffff !important;
  background-color: #4b8c80 !important;
}
.orderManagement-common-workorder-table-detail tr th:nth-child(1),
.orderManagement-common-workorder-table-detail tr td:nth-child(1) {
  width: 105px;
  min-width: 105px;
}
.orderManagement-common-workorder-table-detail tr th:nth-child(2),
.orderManagement-common-workorder-table-detail tr td:nth-child(2) {
  width: 230px;
  min-width: 230px;
}
.orderManagement-common-workorder-table-detail tr th:nth-child(3),
.orderManagement-common-workorder-table-detail tr td:nth-child(3) {
  width: 185px;
  min-width: 185px;
}
.orderManagement-common-workorder-table-detail tr th:nth-child(4),
.orderManagement-common-workorder-table-detail tr td:nth-child(4) {
  width: 500px;
  min-width: 500px;
}
.orderManagement-common-workorder-table-detail tr th:nth-child(5),
.orderManagement-common-workorder-table-detail tr td:nth-child(5) {
  width: 105px;
  min-width: 105px;
}
</style>



// WEBPACK FOOTER //
// src/components/orderManagement/table/commonWorkorderTable.vue